var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
var _b;
import React from 'react';
import styled, { css } from 'styled-components';
import { SPACING_S, SPACING_M, SPACING_L, SPACING_XL } from "../helpers";
import { BACKUP_MATRIX_FORMAT, CELL_ICON_TYPE, SELECT_MODE, CURSOR_EVENT } from './types';
import { getCellMainDataOfCursor, getDataOfHoverDayCaption, getDataOfHoverHourCaption, getDataOfHoverMainCell, getDataOfSelectDayCaption, getDataOfSelectFromDayCaptionToOtherHour, getDataOfSelectFromHourCaptionToOtherDay, getDataOfSelectFromMainCell, getDataOfSelectHourCaption } from './lib-for-Matrix';
import MatrixCell, { STATUS_CELL } from './MatrixCell';
import { Button, BUTTON_VIEW } from "../Button";
import { Radiobutton, NumberInput } from "../controls";
import { Icon } from "../Icon";
import { DeniedIcon, VerifyIcon } from "../icons";
export var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export var DISPLAY_EU_HOURS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
];
export var DISPLAY_CONFIG_VARIANTS = (_a = {},
    _a[BACKUP_MATRIX_FORMAT.eu] = {
        dayStartIndex: 0,
        hours: DISPLAY_EU_HOURS
    },
    _a[BACKUP_MATRIX_FORMAT.us] = {
        dayStartIndex: 6,
        hours: [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },
    _a);
export var getValueAllSelectedCells = function () { return (__assign({}, DAYS.map(function () { return DISPLAY_EU_HOURS.slice(0, -1); }))); };
var WrapperMatrix = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n"], ["\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n"])));
var Col = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Row = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var OPTION_ROW_CSS = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: ", ";\n    align-items: center;\n"], ["\n    height: ", ";\n    align-items: center;\n"])), SPACING_XL);
var SelectOptionButtonWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var StyledRadiobutton = styled(Radiobutton)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
StyledRadiobutton.displayName = 'Radiobutton';
var SelectOptionRow = styled(Row)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n\n    ", "\n\n    ", " {\n        margin-right: ", ";\n    }\n\n    ", " {\n        margin-right: ", ";\n    }\n\n    ", " {\n        margin-left: auto;\n        order: 2;\n\n        ", " {\n            & + ", " {\n                margin-left: ", ";\n            }\n        }\n    }\n"], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n\n    ", "\n\n    ", " {\n        margin-right: ", ";\n    }\n\n    ", " {\n        margin-right: ", ";\n    }\n\n    ", " {\n        margin-left: auto;\n        order: 2;\n\n        ", " {\n            & + ", " {\n                margin-left: ", ";\n            }\n        }\n    }\n"])), SPACING_M, SPACING_S, OPTION_ROW_CSS, MatrixCell, SPACING_S, StyledRadiobutton, SPACING_L, SelectOptionButtonWrapper, Button.selector, Button.selector, SPACING_XL);
var StyledNumberInput = styled(NumberInput)(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
var TimeOptionRow = styled(Row)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n\n    ", " {\n        margin: 0 ", ";\n    }\n\n    ", "\n"], ["\n    ",
    "\n\n    ", " {\n        margin: 0 ", ";\n    }\n\n    ", "\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        color: ", ";\n    "], ["\n        color: ", ";\n    "])), disabled ? theme.colorTextButtonDisabled : theme.colorTextMain);
}, StyledNumberInput, SPACING_S, OPTION_ROW_CSS);
var getRenderDescriptionOverLeftTopCaptionCell = function () { return (React.createElement(Row, null,
    React.createElement(MatrixCell, { isDayCaption: true, iconType: CELL_ICON_TYPE.moon }))); };
var getRenderDescriptionOverMainCells = function () { return (React.createElement(Row, null,
    React.createElement(MatrixCell, { isLong: true, iconType: CELL_ICON_TYPE.sun, text: "AM" }),
    React.createElement(MatrixCell, { isLong: true, iconType: CELL_ICON_TYPE.moon, text: "PM" }))); };
var getRenderSelectOptionCaptionCell = function () { return (React.createElement(SelectOptionRow, null,
    React.createElement(MatrixCell, { indexHour: -1, indexDay: -2, isDayCaption: true, text: "Select:" }))); };
var getRenderTimeOptionCaptionCell = function () { return (React.createElement(TimeOptionRow, null,
    React.createElement(MatrixCell, { indexHour: -1, indexDay: -3, isDayCaption: true }))); };
var defaultProps = {
    disabled: false,
    isSelectMode: false,
    format: BACKUP_MATRIX_FORMAT.eu,
    minValue: 0,
    selectedCells: getValueAllSelectedCells(),
    time: 0,
    cursor: {
        event: CURSOR_EVENT.null
    }
};
export var Matrix = (_b = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            var _a = _this.props, format = _a.format, selectedCells = _a.selectedCells, time = _a.time, isSelectMode = _a.isSelectMode, cursor = _a.cursor;
            _this.format = format;
            _this.hasDataCursor = cursor.event !== CURSOR_EVENT.null;
            _this.dataSelectorId = _this.props['data-selector-id'] || 'matrix';
            _this.onCellMouseDown = _this.onCellMouseDown.bind(_this);
            _this.onCellMouseOver = _this.onCellMouseOver.bind(_this);
            _this.onCellMouseUp = _this.onCellMouseUp.bind(_this);
            _this.onChangeSelectMode = _this.onChangeSelectMode.bind(_this);
            _this.onChangeStartTime = _this.onChangeStartTime.bind(_this);
            _this.onSelectAllCell = _this.onSelectAllCell.bind(_this);
            _this.onUnSelectAllCell = _this.onUnSelectAllCell.bind(_this);
            _this.getRenderLeftTopCaptionCell = _this.getRenderLeftTopCaptionCell.bind(_this);
            _this.getRenderDayCaptionCell = _this.getRenderDayCaptionCell.bind(_this);
            _this.getRenderAllDayCaptionCells = _this.getRenderAllDayCaptionCells.bind(_this);
            _this.getRenderAllHourCaptionCells = _this.getRenderAllHourCaptionCells.bind(_this);
            _this.getRenderMainCell = _this.getRenderMainCell.bind(_this);
            _this.getRenderAllMainCells = _this.getRenderAllMainCells.bind(_this);
            _this.getRenderSelectOptionElements = _this.getRenderSelectOptionElements.bind(_this);
            _this.getRenderTimeOptionElements = _this.getRenderTimeOptionElements.bind(_this);
            _this.getCellDataForDrawBackground = _this.getCellDataForDrawBackground.bind(_this);
            _this.getDataOfSelectElements = _this.getDataOfSelectElements.bind(_this);
            _this.getDataOfHoverElement = _this.getDataOfHoverElement.bind(_this);
            _this.parseAndUpdateState = _this.parseAndUpdateState.bind(_this);
            _this.callPropsOnChange = _this.callPropsOnChange.bind(_this);
            _this.state = {
                selectedCells: selectedCells,
                valueTime: time,
                tmpSelectedCells: {},
                tmpActiveFirstSelectedCell: {},
                cellStatusInfo: null,
                startPosition: {},
                endPosition: {},
                hoverPosition: {},
                isSelectMode: isSelectMode,
                isSelectedDay: false,
                isSelectedHour: false,
                isActive: false,
                cursor: {
                    event: CURSOR_EVENT.onMouseMove
                }
            };
            _this.domNodeRef = React.createRef();
            return _this;
        }
        class_1.prototype.componentWillReceiveProps = function (nextProps) {
            var disabled = nextProps.disabled, _a = nextProps.cursor, cursorX = _a.x, cursorY = _a.y, event = _a.event, resetEvent = nextProps.resetEvent;
            if (!disabled && this.hasDataCursor && cursorX && cursorY) {
                var _b = this.state, tmpSelectedCells = _b.tmpSelectedCells, isActive = _b.isActive, oldStartPosition = _b.startPosition, _c = _b.endPosition, oldStateEndPositionHour = _c.indexHour, oldStateEndPositionDay = _c.indexDay;
                var _d = getCellMainDataOfCursor(this.domNodeRef, this.format, oldStartPosition, { cursorX: cursorX, cursorY: cursorY }), newIndexHour = _d.newIndexHour, newIndexDay = _d.newIndexDay, isOverCell = _d.isOverCell;
                if (newIndexHour != null && newIndexDay != null) {
                    switch (event) {
                        case CURSOR_EVENT.onMouseDown:
                            this.onCellMouseDown(newIndexHour, newIndexDay);
                            resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                            break;
                        case CURSOR_EVENT.onMouseUp:
                            this.onCellMouseUp(newIndexHour, newIndexDay);
                            resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                            break;
                        default:
                            // is CURSOR_EVENT.onMouseMove
                            this.onCellMouseOver(newIndexHour, newIndexDay);
                    }
                }
                else if (event === CURSOR_EVENT.onMouseUp) {
                    if (oldStateEndPositionHour != null && oldStateEndPositionDay != null) {
                        this.onCellMouseUp(oldStateEndPositionHour, oldStateEndPositionDay);
                        resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                    }
                }
                else if (!isOverCell && !isActive && Object.keys(tmpSelectedCells).length > 0) {
                    // is outside Matrix on passive mode
                    this.setState({
                        tmpSelectedCells: {}
                    });
                }
            }
        };
        class_1.prototype.onCellMouseDown = function (indexHour, indexDay) {
            if (!this.hasDataCursor &&
                this.state.startPosition.indexHour &&
                this.state.startPosition.indexDay &&
                this.state.endPosition.indexHour &&
                this.state.endPosition.indexDay) {
                // for fix onMouseDown
                var currState = __assign(__assign({}, this.state), { startPosition: {
                        indexHour: this.state.startPosition.indexHour,
                        indexDay: this.state.startPosition.indexDay
                    }, endPosition: {
                        indexHour: this.state.endPosition.indexHour,
                        indexDay: this.state.endPosition.indexDay
                    } });
                this.parseAndUpdateState(false, currState);
            }
            else {
                var startPosition = { indexHour: indexHour, indexDay: indexDay };
                this.parseAndUpdateState(true, __assign(__assign({}, this.state), { startPosition: startPosition, endPosition: startPosition, isSelectedHour: indexDay === -1, isSelectedDay: indexHour === -1, isActive: true }));
            }
        };
        class_1.prototype.onCellMouseOver = function (indexHour, indexDay) {
            var hoverPosition = { indexHour: indexHour, indexDay: indexDay };
            var endIndexHourTMP = indexHour;
            var endIndexDayTMP = indexDay;
            if (this.state.startPosition.indexHour !== undefined &&
                this.state.startPosition.indexDay !== undefined &&
                (this.state.startPosition.indexHour === -1 ||
                    this.state.startPosition.indexDay === -1 ||
                    (this.state.startPosition.indexHour > -1 && this.state.startPosition.indexDay > -1))) {
                var currState = __assign(__assign({}, this.state), { startPosition: {
                        indexHour: this.state.startPosition.indexHour,
                        indexDay: this.state.startPosition.indexDay
                    } });
                var _a = this.state.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay;
                if (startPositionIndexHour > -1 && indexHour < 0) {
                    // for cancel select all hours
                    endIndexHourTMP = 0;
                }
                if (startPositionIndexDay > -1 && indexDay < 0) {
                    // for correct select cells when cursor over hour caption
                    endIndexDayTMP = DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex;
                }
                this.parseAndUpdateState(true, __assign(__assign({}, currState), { endPosition: {
                        indexHour: endIndexHourTMP,
                        indexDay: endIndexDayTMP
                    }, hoverPosition: hoverPosition }));
            }
            else {
                this.parseAndUpdateState(true, __assign(__assign({}, this.state), { tmpSelectedCells: {}, startPosition: {}, hoverPosition: hoverPosition, isSelectedHour: false, isSelectedDay: false }));
            }
        };
        class_1.prototype.onCellMouseUp = function (indexHour, indexDay) {
            this.parseAndUpdateState(false, __assign(__assign({}, this.state), { endPosition: { indexHour: indexHour, indexDay: indexDay }, isActive: false }));
        };
        class_1.prototype.onChangeSelectMode = function (value) {
            this.setState({
                isSelectMode: value === SELECT_MODE.permitted,
                tmpSelectedCells: {},
                tmpActiveFirstSelectedCell: {}
            });
        };
        class_1.prototype.onChangeStartTime = function (valueTime) {
            // value time changed by NumberField
            this.setState({
                valueTime: valueTime
            }, this.callPropsOnChange);
        };
        class_1.prototype.onSelectAllCell = function () {
            this.setState({
                selectedCells: getValueAllSelectedCells(),
                tmpSelectedCells: {},
                tmpActiveFirstSelectedCell: {}
            }, this.callPropsOnChange);
        };
        class_1.prototype.onUnSelectAllCell = function () {
            this.setState({
                selectedCells: {},
                tmpSelectedCells: {},
                tmpActiveFirstSelectedCell: {}
            }, this.callPropsOnChange);
        };
        class_1.prototype.getRenderLeftTopCaptionCell = function () {
            // It's cell at the intersection of captions of the day and hours
            return (React.createElement(Row, null,
                React.createElement(MatrixCell, { indexHour: -1, indexDay: -1, text: DISPLAY_CONFIG_VARIANTS[this.format].hours[0] })));
        };
        class_1.prototype.getRenderAllHourCaptionCells = function () {
            var _this = this;
            var _a = this.state.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellIndexHour = _a.indexHour, tmpActiveFirstSelectedCellIndexDay = _a.indexDay, tmpActiveFirstSelectedCellStatus = _a.status;
            return (React.createElement(Row, null, DISPLAY_EU_HOURS.slice(1).map(function (displayHour) {
                var showHour = DISPLAY_CONFIG_VARIANTS[_this.format].hours[displayHour];
                var indexHour = displayHour - 1;
                var _a = _this.getCellDataForDrawBackground(indexHour, -1, tmpActiveFirstSelectedCellIndexHour === indexHour &&
                    tmpActiveFirstSelectedCellIndexDay === -1
                    ? tmpActiveFirstSelectedCellStatus
                    : null), isDrawnLink = _a.isDrawnLink, status = _a.status;
                // hour caption cell
                return (React.createElement(MatrixCell, { key: "matrix-cell-hour-caption-" + indexHour + "--1", indexHour: indexHour, indexDay: -1, text: showHour, isDrawnLink: isDrawnLink, status: status }));
            })));
        };
        class_1.prototype.getRenderDayCaptionCell = function (indexDay) {
            var _a = this.state.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellIndexHour = _a.indexHour, tmpActiveFirstSelectedCellIndexDay = _a.indexDay, tmpActiveFirstSelectedCellStatus = _a.status;
            var _b = this.getCellDataForDrawBackground(-1, indexDay, tmpActiveFirstSelectedCellIndexHour === -1 &&
                tmpActiveFirstSelectedCellIndexDay === indexDay
                ? tmpActiveFirstSelectedCellStatus
                : null), isDrawnLink = _b.isDrawnLink, status = _b.status;
            return (React.createElement(Row, { key: "matrix-row-day-caption--1-" + indexDay },
                React.createElement(MatrixCell, { key: "matrix-cell-day-caption--1-" + indexDay, indexHour: -1, indexDay: indexDay, isDayCaption: true, text: DAYS[indexDay], isDrawnLink: isDrawnLink, status: status })));
        };
        class_1.prototype.getRenderAllDayCaptionCells = function () {
            var _this = this;
            var rows = [];
            if (this.format === BACKUP_MATRIX_FORMAT.us) {
                rows.push(this.getRenderDayCaptionCell(DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex));
            }
            rows = DAYS.reduce(function (renderDayCaptionCell, currentRows, indexDay) {
                return _this.format === BACKUP_MATRIX_FORMAT.us &&
                    indexDay >= DISPLAY_CONFIG_VARIANTS[_this.format].dayStartIndex
                    ? renderDayCaptionCell
                    : renderDayCaptionCell.concat(_this.getRenderDayCaptionCell(indexDay));
            }, rows);
            return rows;
        };
        class_1.prototype.getRenderMainCell = function (indexDay) {
            var _this = this;
            var _a = this.state.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellIndexHour = _a.indexHour, tmpActiveFirstSelectedCellIndexDay = _a.indexDay, tmpActiveFirstSelectedCellStatus = _a.status;
            return (React.createElement(Row, { key: "matrix-row-cell-main-" + indexDay }, DISPLAY_EU_HOURS.slice(0, DISPLAY_EU_HOURS.length - 1).map(function (indexHour) {
                var status = _this.getCellDataForDrawBackground(indexHour, indexDay, tmpActiveFirstSelectedCellIndexHour === indexHour &&
                    tmpActiveFirstSelectedCellIndexDay === indexDay
                    ? tmpActiveFirstSelectedCellStatus
                    : null).status;
                return (React.createElement(MatrixCell, { key: "matrix-cell-main-" + indexHour + "-" + indexDay, indexHour: indexHour, indexDay: indexDay, status: status }));
            })));
        };
        class_1.prototype.getRenderAllMainCells = function () {
            var _this = this;
            var rows = [];
            if (this.format === BACKUP_MATRIX_FORMAT.us) {
                rows.push(this.getRenderMainCell(DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex));
            }
            rows = DAYS.reduce(function (renderMainCell, currentRows, indexDay) {
                return _this.format === BACKUP_MATRIX_FORMAT.us &&
                    indexDay >= DISPLAY_CONFIG_VARIANTS[_this.format].dayStartIndex
                    ? renderMainCell
                    : renderMainCell.concat(_this.getRenderMainCell(indexDay));
            }, rows);
            return rows;
        };
        class_1.prototype.getRenderSelectOptionElements = function () {
            var _this = this;
            var disabled = this.props.disabled;
            var isSelectMode = this.state.isSelectMode;
            return (React.createElement(SelectOptionRow, null,
                React.createElement(MatrixCell, { status: STATUS_CELL.UNSELECTED, isDemo: true }),
                React.createElement(StyledRadiobutton, { value: SELECT_MODE.denied, checked: !isSelectMode, onChange: function (value) { return _this.onChangeSelectMode(value); }, disabled: disabled, "data-selector-id": this.dataSelectorId + "-denied-control" }, "Denied"),
                React.createElement(MatrixCell, { status: STATUS_CELL.SELECTED, isDemo: true }),
                React.createElement(StyledRadiobutton, { value: SELECT_MODE.permitted, checked: isSelectMode, onChange: function (value) { return _this.onChangeSelectMode(value); }, disabled: disabled, "data-selector-id": this.dataSelectorId + "-permitted-control" }, "Permitted"),
                React.createElement(SelectOptionButtonWrapper, null,
                    React.createElement(Button, { ui: BUTTON_VIEW.text, onClick: this.onUnSelectAllCell, disabled: disabled, "data-selector-id": this.dataSelectorId + "-deny-all-control" },
                        React.createElement(Icon, { src: React.createElement(DeniedIcon, null) }),
                        "Deny All"),
                    React.createElement(Button, { ui: BUTTON_VIEW.text, onClick: this.onSelectAllCell, disabled: disabled, "data-selector-id": this.dataSelectorId + "-permit-all-control" },
                        React.createElement(Icon, { src: React.createElement(VerifyIcon, null) }),
                        "Permit All"))));
        };
        class_1.prototype.getRenderTimeOptionElements = function () {
            var _a = this.props, disabled = _a.disabled, maxValue = _a.maxValue, minValue = _a.minValue;
            var valueTime = this.state.valueTime;
            return (React.createElement(TimeOptionRow, { disabled: disabled },
                "Start time within an hour:",
                React.createElement(StyledNumberInput, { disabled: disabled, value: valueTime, onChange: this.onChangeStartTime, maxValue: maxValue, minValue: minValue, "data-selector-id": this.dataSelectorId + "-time-control" }),
                "min"));
        };
        class_1.prototype.getCellDataForDrawBackground = function (indexHour, indexDay, extStatus) {
            if (extStatus === void 0) { extStatus = null; }
            var isDrawnLink = false;
            var status;
            if (extStatus !== null) {
                status = extStatus;
            }
            else {
                var _a = this.state, selectedCells = _a.selectedCells, tmpSelectedCells = _a.tmpSelectedCells, isSelectMode = _a.isSelectMode, isSelectedDay = _a.isSelectedDay, isSelectedHour = _a.isSelectedHour, isActive = _a.isActive, tmpActiveFirstSelectedCell = _a.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellStatus = _a.tmpActiveFirstSelectedCell.status;
                var isTmpNearSelectedCells = false;
                var isSelected = indexHour !== -1 &&
                    indexDay !== -1 &&
                    selectedCells &&
                    Object.prototype.hasOwnProperty.call(selectedCells, indexDay) &&
                    selectedCells[indexDay].includes(indexHour);
                var isTmpSelectedCells = tmpSelectedCells &&
                    Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay) &&
                    tmpSelectedCells[indexDay].includes(indexHour);
                if (!isSelectedHour &&
                    indexHour === -1 &&
                    tmpSelectedCells &&
                    Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay)) {
                    isTmpNearSelectedCells = true;
                    if (this.format === BACKUP_MATRIX_FORMAT.us) {
                        if (indexDay === 5) {
                            isDrawnLink = false;
                        }
                        else if (indexDay < 5) {
                            isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay + 1);
                        }
                        else {
                            isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, 0);
                        }
                    }
                    else {
                        // if is BACKUP_MATRIX_FORMAT.eu'
                        isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay + 1);
                    }
                }
                else if (!isSelectedDay && indexDay === -1 && tmpSelectedCells) {
                    for (var dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek += 1) {
                        if (Object.prototype.hasOwnProperty.call(tmpSelectedCells, dayOfWeek) &&
                            tmpSelectedCells[dayOfWeek].includes(indexHour)) {
                            isTmpNearSelectedCells = true;
                        }
                        if (Object.prototype.hasOwnProperty.call(tmpSelectedCells, dayOfWeek) &&
                            tmpSelectedCells[dayOfWeek].includes(indexHour + 1)) {
                            isDrawnLink = true;
                        }
                        if (isTmpNearSelectedCells || isDrawnLink) {
                            break;
                        }
                    }
                }
                if (isTmpNearSelectedCells) {
                    status = isSelectMode ? STATUS_CELL.SELECT_HOVER : STATUS_CELL.UNSELECT_HOVER;
                }
                else if (isTmpSelectedCells) {
                    if (isActive &&
                        Object.prototype.hasOwnProperty.call(tmpActiveFirstSelectedCell, 'status') &&
                        (isSelectedDay || isSelectedHour)) {
                        status = tmpActiveFirstSelectedCellStatus;
                    }
                    else if (isSelectMode) {
                        status = isSelected ? STATUS_CELL.SELECTED : STATUS_CELL.SELECT_HOVER;
                    }
                    else {
                        status = !isSelected ? STATUS_CELL.UNSELECTED : STATUS_CELL.UNSELECT_HOVER;
                    }
                }
                else if (indexHour === -1 || indexDay === -1) {
                    status = STATUS_CELL.DISABLED;
                }
                else if (isSelected) {
                    status = STATUS_CELL.SELECTED;
                }
                else {
                    status = STATUS_CELL.UNSELECTED;
                }
            }
            return {
                status: status,
                isDrawnLink: isDrawnLink
            };
        };
        class_1.prototype.getDataOfSelectElements = function (isProcessSelect, tmpEditedState) {
            var tmpEditedStateCopy = tmpEditedState;
            var selectedCells = tmpEditedStateCopy.selectedCells, _a = tmpEditedStateCopy.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay, _b = tmpEditedStateCopy.endPosition, endPositionIndexHour = _b.indexHour, endPositionIndexDay = _b.indexDay, _c = tmpEditedStateCopy.hoverPosition, hoverPositionIndexHour = _c.indexHour, hoverPositionIndexDay = _c.indexDay;
            var resultSelectedCells = {};
            if (startPositionIndexHour === -1 && endPositionIndexHour !== startPositionIndexHour) {
                var DataOfSelectCells = getDataOfSelectFromDayCaptionToOtherHour(this.format, isProcessSelect, tmpEditedStateCopy);
                tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (startPositionIndexHour === -1 && startPositionIndexDay === endPositionIndexDay) {
                // select day
                var DataOfSelectCells = getDataOfSelectDayCaption(isProcessSelect, tmpEditedStateCopy);
                tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
                tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                    DataOfSelectCells.tmpActiveFirstSelectedCell;
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (startPositionIndexDay === -1 && endPositionIndexDay !== startPositionIndexDay) {
                var DataOfSelectCells = getDataOfSelectFromHourCaptionToOtherDay(this.format, isProcessSelect, tmpEditedStateCopy);
                tmpEditedStateCopy.isSelectedHour = DataOfSelectCells.isSelectedHour;
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (startPositionIndexDay === -1 &&
                startPositionIndexHour === endPositionIndexHour) {
                // select hour
                var DataOfSelectCells = getDataOfSelectHourCaption(isProcessSelect, tmpEditedStateCopy);
                tmpEditedStateCopy.isSelectedHour = DataOfSelectCells.isSelectedHour;
                tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                    DataOfSelectCells.tmpActiveFirstSelectedCell;
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (startPositionIndexHour !== -1 && startPositionIndexDay !== -1) {
                // select area on matrix cells
                var DataOfSelectCells = getDataOfSelectFromMainCell(this.format, isProcessSelect, tmpEditedStateCopy);
                tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
                tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                    DataOfSelectCells.tmpActiveFirstSelectedCell;
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else {
                resultSelectedCells = isProcessSelect ? {} : selectedCells;
            }
            var _d = tmpEditedStateCopy.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellIndexHour = _d.indexHour, tmpActiveFirstSelectedCellIndexDay = _d.indexDay;
            if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
                tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
                tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
            }
            return {
                tmpEditedStateCopy: tmpEditedStateCopy,
                resultSelectedCells: resultSelectedCells
            };
        };
        class_1.prototype.getDataOfHoverElement = function (isProcessSelect, tmpEditedState) {
            var tmpEditedStateCopy = tmpEditedState;
            var _a = tmpEditedStateCopy.hoverPosition, hoverPositionIndexHour = _a.indexHour, hoverPositionIndexDay = _a.indexDay;
            var resultSelectedCells = {};
            if (hoverPositionIndexHour === -1) {
                // hover day caption
                var DataOfSelectCells = getDataOfHoverDayCaption(isProcessSelect, tmpEditedStateCopy);
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (hoverPositionIndexDay === -1) {
                // hover hour caption
                var DataOfSelectCells = getDataOfHoverHourCaption(this.props.cursor.event, this.format, isProcessSelect, tmpEditedStateCopy);
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            else if (hoverPositionIndexHour >= 0 && hoverPositionIndexDay >= 0) {
                var DataOfSelectCells = getDataOfHoverMainCell(isProcessSelect, tmpEditedStateCopy);
                resultSelectedCells = DataOfSelectCells.selectedCells;
            }
            return {
                resultSelectedCells: resultSelectedCells
            };
        };
        class_1.prototype.parseAndUpdateState = function (isProcessSelect, tmpEditedState) {
            var tmpEditedStateCopy = JSON.parse(JSON.stringify(tmpEditedState));
            var _a = tmpEditedStateCopy.tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCellIndexHour = _a.indexHour, tmpActiveFirstSelectedCellIndexDay = _a.indexDay, startPosition = tmpEditedStateCopy.startPosition, endPosition = tmpEditedStateCopy.endPosition, _b = tmpEditedStateCopy.hoverPosition, hoverPositionIndexHour = _b.indexHour, hoverPositionIndexDay = _b.indexDay;
            if (startPosition.indexHour !== undefined &&
                startPosition.indexDay !== undefined &&
                endPosition.indexHour !== undefined &&
                endPosition.indexDay !== undefined) {
                var _c = this.getDataOfSelectElements(isProcessSelect, __assign(__assign({}, tmpEditedState), { startPosition: {
                        indexHour: startPosition.indexHour,
                        indexDay: startPosition.indexDay
                    }, endPosition: {
                        indexHour: endPosition.indexHour,
                        indexDay: endPosition.indexDay
                    } })), tmpSecondEditedStateCopy = _c.tmpEditedStateCopy, resultSelectedCells = _c.resultSelectedCells;
                if (isProcessSelect) {
                    this.setState(__assign(__assign(__assign({}, tmpEditedStateCopy), tmpSecondEditedStateCopy), { tmpSelectedCells: resultSelectedCells }));
                }
                else {
                    this.setState(__assign(__assign(__assign({}, tmpEditedStateCopy), tmpSecondEditedStateCopy), { tmpSelectedCells: {}, selectedCells: resultSelectedCells, startPosition: {}, endPosition: {}, isSelectedHour: false, isSelectedDay: false, isActive: false }), this.callPropsOnChange);
                }
            }
            else if (isProcessSelect &&
                hoverPositionIndexHour !== undefined &&
                hoverPositionIndexDay !== undefined) {
                var dataOfSelectElements = this.getDataOfHoverElement(isProcessSelect, tmpEditedState);
                if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
                    tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
                    tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
                }
                this.setState(__assign(__assign({}, tmpEditedStateCopy), { tmpSelectedCells: dataOfSelectElements.resultSelectedCells, isSelectedHour: hoverPositionIndexDay === -1, isSelectedDay: hoverPositionIndexHour === -1 }));
            }
            else if (!isProcessSelect) {
                if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
                    tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
                    tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
                }
                this.setState(__assign(__assign({}, tmpEditedStateCopy), { startPosition: {}, endPosition: {} }));
            }
        };
        class_1.prototype.callPropsOnChange = function () {
            var onChange = this.props.onChange;
            var _a = this.state, cells = _a.selectedCells, time = _a.valueTime;
            onChange === null || onChange === void 0 ? void 0 : onChange({ cells: cells, time: time });
        };
        class_1.prototype.render = function () {
            var renderDescriptionOverLeftTopCaptionCell = getRenderDescriptionOverLeftTopCaptionCell();
            var renderDescriptionOverMainCells = getRenderDescriptionOverMainCells();
            var renderLeftTopCaptionCell = this.getRenderLeftTopCaptionCell();
            var renderDayCaptionCells = this.getRenderAllDayCaptionCells();
            var renderHourCaptionCells = this.getRenderAllHourCaptionCells();
            var renderMainCells = this.getRenderAllMainCells();
            var renderSelectOptionCaptionCell = getRenderSelectOptionCaptionCell();
            var renderSelectOptionElements = this.getRenderSelectOptionElements();
            var renderTimeOptionCaptionCell = getRenderTimeOptionCaptionCell();
            var renderTimeOptionElements = this.getRenderTimeOptionElements();
            return (React.createElement(WrapperMatrix, { ref: this.domNodeRef, "data-selector-id": this.props['data-selector-id'] || 'matrix' },
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        renderDescriptionOverLeftTopCaptionCell,
                        renderLeftTopCaptionCell,
                        renderDayCaptionCells,
                        renderSelectOptionCaptionCell,
                        renderTimeOptionCaptionCell),
                    React.createElement(Col, null,
                        renderDescriptionOverMainCells,
                        renderHourCaptionCells,
                        renderMainCells,
                        renderSelectOptionElements,
                        renderTimeOptionElements))));
        };
        return class_1;
    }(React.Component)),
    _b.defaultProps = defaultProps,
    _b);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Matrix.js.map